import React from 'react';
import './ExpenseDate.css'
import Card from "../UI/Card";

const ExpenseDate = (props) => {
    const month = props.date.toLocaleString('en-US', {month: 'long'});
    const day = props.date.toLocaleString('en-US', {day: 'numeric'});
    const year = props.date.toLocaleString('en-US', {year: 'numeric'});
   return (
    <Card className="expense-date">
      <div className="expense-date__month">{month}</div>
      <div className="expense-date__day">{day}</div>
      <div className="expense-date__year">{year}</div>
    </Card>
  )
}

export default ExpenseDate;
